import { render, staticRenderFns } from "./BookingPassenger.vue?vue&type=template&id=7d54b694&scoped=true&"
import script from "./BookingPassenger.vue?vue&type=script&lang=ts&"
export * from "./BookingPassenger.vue?vue&type=script&lang=ts&"
import style0 from "./BookingPassenger.vue?vue&type=style&index=0&id=7d54b694&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d54b694",
  null
  
)

export default component.exports